import React, { useState } from "react";
import { useEffect } from "react";
import { useShiftDate } from "./Hooks";
import Loading from "../../../../../Common/Components/Loading";
import {
  CostRender,
  ToDateJalali,
  ConvertDate,
  GenderRender,
} from "../../../../../Common/Function";
import CustomModal from "../../../../../Common/Components/Modal/CustomModal";
import DatePicker, {
  Calendar,
  getAllDatesInRange,
} from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import TimePicker from "react-multi-date-picker/plugins/analog_time_picker";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";

function Index() {
  const {
    list,
    loading,
    getShifts,
    setModal,
    modal,
    updateTimeTable,
    form,
    setForm,
    date,
    setDate,
  } = useShiftDate();
  useEffect(() => {
    getShifts();
  }, []);

  const location = useLocation();
  const item = location.data;
  const { type } = item.time_table;
  return (
    <div className="card">
      <div className="card-body">
        <div className="row">
          <div className="col">
            <h6>ویرایش شیفت های مجموعه ها</h6>
          </div>
        </div>

        {!loading.list &&
          list.data.times.map((time, key) => {
            return (
              <button
                key={key}
                onClick={() => setDate(time.date)}
                className={`btn ${time.date == date && "btn-danger"} ml-2`}
              >
                {ToDateJalali(time.date)}
              </button>
            );
          })}

        <div className="row">
          {loading.list ? (
            <Loading count={1} col={12} height={300} />
          ) : (
            list.shifts.map((shift, key) => {
              if (date) {
                if (shift.date == date) {
                  return (
                    <ShiftDate
                      key={key}
                      shift={shift}
                      modal={modal}
                      setModal={setModal}
                      type={type}
                    />
                  );
                }
              } else {
                return (
                  <ShiftDate
                    type={type}
                    shift={shift}
                    modal={modal}
                    setModal={setModal}
                  />
                );
              }
            })
          )}
          {!loading.list && (
            <CustomModal
              show={modal}
              handleClose={() => {
                setModal(false);
                getShifts();
              }}
              header={modal == "new" ? "ایجاد شیفت" : "ویرایش شیفت"}
            >
              <Guid type={type} data={modal} list={list} />
            </CustomModal>
          )}
        </div>
        <button
          className="btn btn-primary mt-4"
          onClick={() => setModal({ step: "add" })}
        >
          اضافه کردن شیفت جدید
        </button>
      </div>
    </div>
  );
}

export default Index;
const Guid = ({ data, list, type }) => {
  const { user } = useSelector(state => state);
  const [step, setStep] = useState("select");
  const {
    updateTimeTable,
    loadingBtn,
    reserveByManager,
    statusHandler,
    cancelByManager,
    checkDate,
  } = useShiftDate();
  useEffect(() => {
    if (data.step) {
      setStep(data.step);
    }
  }, []);

  const [state, setState] = useState({});
  const [contract, setContract] = useState({
    contract_type: "onceaweek",
  });
  useEffect(() => {
    window.$(`.clockpicker`).on("change", e => {
      let hours = window.$(e.target).clockpicker().data().clockpicker.hours;
      let minutes = window.$(e.target).clockpicker().data().clockpicker.minutes;
      window.$(e.target).attr("data-hours", hours);
      window.$(e.target).attr("data-minutes", minutes);
    });

    var inputs = window.$(".clockpicker");
    window.$.each(inputs, function (i, item) {
      window.$(item).clockpicker({
        donetext: "انجام شد",
        align: "right",
        autoclose: true,
      });
    });
  }, []);

  const renderSteps = () => {
    switch (step) {
      case 1:
      case "add":
        return (
          <div>
            <div className="row ">
              <div className="col d-flex justify-content-end">
                <button className="btn" onClick={() => setStep("select")}>
                  <span>بازگشت</span>
                  <i className="fas fa-angle-left mx-2"></i>
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <label htmlFor="price">عنوان</label>
                <input
                  onChange={e => setState({ ...state, title: e.target.value })}
                  type="text"
                  className="form-control"
                  placeholder="عنوان"
                  defaultValue={data && data.title}
                  id="price"
                />
              </div>
              {/* shiftwdatewcount */}
              <div className="col-md-4">
                <label htmlFor="price">قیمت</label>
                <input
                  onChange={e => setState({ ...state, price: +e.target.value })}
                  type="number"
                  number="form-control"
                  placeholder="قیمت"
                  defaultValue={data && +data.price}
                  id="price"
                />
              </div>
              {type == "shiftwdatewcount" && (
                <div className="col-md-4">
                  <label htmlFor="price">ظرفیت</label>
                  <input
                    onChange={e =>
                      setState({ ...state, count: e.target.value })
                    }
                    type="number"
                    className="form-control"
                    placeholder="ظرفیت"
                    defaultValue={data && data.count}
                    id="price"
                  />
                </div>
              )}

              <div className="col-md-4">
                <label htmlFor="">جنسیت</label>
                <select
                  name=""
                  id=""
                  className="form-control form-control-sm"
                  onChange={e => setState({ ...state, gender: e.target.value })}
                >
                  <option value={false}>انتخاب کنید</option>
                  <option value="men" selected={data && data.gender == "men"}>
                    آقایان
                  </option>
                  <option
                    value="women"
                    selected={data && data.gender == "women"}
                  >
                    بانوان
                  </option>
                </select>
              </div>
              <div className="col-md-6">
                <label htmlFor="price">ساعت شروع</label>
                <input
                  type="text"
                  className="form-control clockpicker"
                  placeholder="شروع شیفت"
                  id="clockpicker-2"
                  autoComplete={"off"}
                  defaultValue={data && data.start}
                  onClick={() => {
                    if (window.$(".clockpicker").length) {
                      var inputs = window.$(".clockpicker");
                      window.$.each(inputs, function (i, item) {
                        window.$(item).clockpicker({
                          donetext: "انجام شد",
                          align: "right",
                          autoclose: true,
                        });
                      });
                    }
                    window.$(`#clockpicker-2`).on("change", e => {
                      let hours = window.$(e.target).clockpicker().data()
                        .clockpicker.hours;
                      let minutes = window.$(e.target).clockpicker().data()
                        .clockpicker.minutes;
                      window.$(e.target).attr("data-hours", hours);
                      window.$(e.target).attr("data-minutes", minutes);
                      if (minutes < 10) {
                        minutes = "0" + minutes.toString();
                      }
                      if (hours < 10) {
                        hours = "0" + hours.toString();
                      }

                      setState({
                        ...state,
                        start: `${hours}:${minutes}`,
                      });
                    });
                  }}
                />
              </div>
              <div className="col-md-6">
                <label htmlFor="price">ساعت پایان</label>
                <input
                  type="text"
                  className="form-control clockpicker"
                  placeholder="شروع شیفت"
                  id="clockpicker-1"
                  autoComplete={"off"}
                  defaultValue={data && data.end}
                  onClick={() => {
                    if (window.$(".clockpicker").length) {
                      var inputs = window.$(".clockpicker");
                      window.$.each(inputs, function (i, item) {
                        window.$(item).clockpicker({
                          donetext: "انجام شد",
                          align: "right",
                          autoclose: true,
                        });
                      });
                    }
                    window.$(`#clockpicker-1`).on("change", e => {
                      let hours = window.$(e.target).clockpicker().data()
                        .clockpicker.hours;
                      let minutes = window.$(e.target).clockpicker().data()
                        .clockpicker.minutes;
                      window.$(e.target).attr("data-hours", hours);
                      window.$(e.target).attr("data-minutes", minutes);
                      if (minutes < 10) {
                        minutes = "0" + minutes.toString();
                      }
                      if (hours < 10) {
                        hours = "0" + hours.toString();
                      }

                      setState({
                        ...state,
                        end: `${hours}:${minutes}`,
                      });
                    });
                  }}
                />
              </div>
              {step == "add" && (
                <div className="col-md-6">
                  <label htmlFor="">تاریخ شیفت</label>
                  <Calendar
                    onChange={data => {
                      setState({
                        ...state,
                        date: ConvertDate(
                          `${data.year}/${data.month.number}/${data.day}`
                        ),
                      });
                    }}
                    calendar={persian}
                    locale={persian_fa}
                  />
                </div>
              )}
            </div>

            <div className="row">
              <div className="col">
                <button
                  disabled={loadingBtn}
                  className="btn btn-primary text-white my-2"
                  onClick={() => {
                    if (step == 1) {
                      updateTimeTable({
                        id: data.id,
                        day: data.day,
                        ...state,
                      });
                    } else {
                      checkDate(state, list);
                    }
                  }}
                >
                  {loadingBtn ? "در حال پردازش" : "ثبت اطلاعات"}
                </button>
              </div>
            </div>
          </div>
        );
      case 2:
        return (
          <div>
            <div className="row justify-content-end">
              <div className="col-2">
                <button className="btn" onClick={() => setStep("select")}>
                  <span>بازگشت</span>
                  <i className="fas fa-angle-left mx-2"></i>
                </button>
              </div>
            </div>
            <div className="col-md-6">
              <label htmlFor="">قیمت دوم</label>
              <input
                onChange={e =>
                  setState({ ...state, second_price: e.target.value })
                }
                type="text"
                className="form-control"
                placeholder="قیمت"
                defaultValue={data && data.second_price}
                id="price"
              />
            </div>
            <div className="col-md-6 elements_sans" id="start">
              <label>پایان اعتبار قیمت دوم</label>
              <Calendar
                onChange={data => {
                  setState({
                    ...state,
                    second_exp: ConvertDate(
                      `${data.year}/${data.month.number}/${data.day}`
                    ),
                  });
                }}
                calendar={persian}
                // multiple={true}
                locale={persian_fa}
              />
            </div>
            <div className="row">
              <div className="col">
                <button
                  className="btn btn-primary"
                  disabled={loadingBtn}
                  onClick={() =>
                    updateTimeTable({
                      ...state,
                      day: data.day,
                      id: data.id,
                    })
                  }
                >
                  {loadingBtn ? "در حال بررسی" : "ثبت قیمت دوم"}
                </button>
              </div>
            </div>
          </div>
        );
      case 3:
        return (
          <div>
            <div className="row justify-content-end">
              <div className="col-2">
                <button className="btn" onClick={() => setStep("select")}>
                  <span>بازگشت</span>
                  <i className="fas fa-angle-left mx-2"></i>
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">{`شیفت ${data.title} حذف شود ؟؟`}</div>
            </div>{" "}
            <div className="row mt-3">
              <div className="col">
                <div>
                  <button
                    className="btn btn-primary"
                    disabled={loadingBtn}
                    onClick={() => {
                      updateTimeTable({
                        delete: data.id,
                        day: data.day,
                      });
                    }}
                  >
                    {loadingBtn ? "در حال پردازش" : "بله"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      case "select":
        return (
          <div className="d-flex justify-content-between flex-column">
            <button
              className="btn  mb-2 d-flex justify-content-between"
              onClick={() => setStep(1)}
            >
              <span>ویرایش شیفت</span>{" "}
              <i className="fas fa-angle-left mx-2"></i>
            </button>

            <button
              className="btn  mb-2 d-flex justify-content-between"
              onClick={() => setStep(2)}
            >
              <span>ثبت قیمت دوم</span>
              <i className="fas fa-angle-left mx-2"></i>
            </button>
            <button
              className="btn  mb-2 d-flex justify-content-between"
              onClick={() => setStep(3)}
            >
              <span>حذف شیفت</span>
              <i className="fas fa-angle-left mx-2"></i>
            </button>
          </div>
        );
    }
  };
  return renderSteps();
};
const ShiftDate = ({ shift, method, setModal, type }) => {
  const { user } = useSelector(state => state);

  return (
    <div className="col-md-4 col-sm-6 col-lg-3 mt-2">
      <div className="p-2  border rounded">
        <div className="d-flex justify-content-between">
          <span>نام شیفت</span>
          <span>{shift.title}</span>
        </div>
        <div className="d-flex justify-content-between">
          <span>تاریخ شیفت</span>
          <span>{ToDateJalali(shift.date)}</span>
        </div>
        <div className="d-flex justify-content-between">
          <span>شروع</span>
          <span>{shift.start}</span>
        </div>
        <div className="d-flex justify-content-between">
          <span>پایان</span>
          <span>{shift.end}</span>
        </div>
        <div className="d-flex justify-content-between">
          <span>قیمت</span>
          <span>{CostRender.format(shift.price)} تومان</span>
        </div>
        <div className="d-flex justify-content-between">
          <span>ویژه</span>
          <span>{GenderRender(shift.gender)}</span>
        </div>
        {type == "shiftwdatewcount" && (
          <div className="d-flex justify-content-between">
            <span>ظرفیت</span>
            <span>{shift.count}</span>
          </div>
        )}
        {shift.second_price && (
          <>
            <div className="d-flex justify-content-between">
              <span>قیمت دوم</span>
              <span>{CostRender.format(shift.second_price)} تومان</span>
            </div>
            <div className="d-flex justify-content-between">
              <span>تاریخ اتمام قیمت دوم</span>
              <span>{ToDateJalali(shift.second_exp)}</span>
            </div>
          </>
        )}

        <div className="d-flex justify-content-center">
          <button onClick={() => setModal(shift)} className="btn btn-primary">
            ویرایش
          </button>
        </div>
      </div>
    </div>
  );
};
